import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useSearch } from "./SearchContext";

export interface IPaginationProps {
  className?: string;
  onPageChangeScrollTo?: () => void;
}

export const Pagination: React.FC<IPaginationProps> = ({ className, onPageChangeScrollTo }) => {
  const context = useSearch();
  const linkClass =
    "inline-block mb-4 px-3 py-2 rounded-sm border-accent border hover:bg-action hover:text-action-text ";

  const [isClient, setIsClient] = useState(false)
  useEffect(() => { setIsClient(true) }, [])
  if (!isClient) {
    /**
     * For SEO
     */
    const pageCount = Math.ceil(context.currentResults.length / context.perPage)
    let allPages: number[] = Array.from({ length: pageCount }, (_, i) => i + 1);

    return (
      <ul className="hidden">
        {allPages.map((p, i) => (
          <li key={i}><a href={`?page=${p}`}></a></li>
        ))}
      </ul>
    )
  }

  return (
    <ReactPaginate
      pageCount={Math.ceil(context.currentResults.length / context.perPage)}
      onPageChange={({ selected }) => {
        if (onPageChangeScrollTo) {
          onPageChangeScrollTo();
        }
        else {
          window?.scrollTo({ top: 0, behavior: "smooth" });
        }
        context.setPage && context.setPage(selected + 1);
      }}
      className={`flex flex-wrap justify-center text-xl gap-x-4 gap-y-1 ${className}`}
      pageLinkClassName={linkClass}
      breakLinkClassName={linkClass}
      nextLinkClassName={linkClass}
      previousLinkClassName={linkClass}
      activeLinkClassName="bg-action text-action-text"
      forcePage={context.page && context.page - 1}
      hrefAllControls={true}
      hrefBuilder={(pageIndex, pageCount, selectedPage) => {
        if (typeof window === 'undefined') {
          //return "#";
          return `?page=${pageIndex.toString()}`
        }
        let urlParams = new URLSearchParams(window?.location?.hash);
        return `${window?.location?.pathname}${`?page=${pageIndex.toString()}`}${urlParams.toString()}`;
      }}
    />
  );
};
